import { PERMISSIONS } from "@miplatform/constants";
import { PlatformModules } from "@miplatform/types";

export const getModulesByAccessPermissions = (permissions: string[]) => {
  const modules: PlatformModules[] = [];

  if (permissions.includes(PERMISSIONS.MI_DISPATCH.ACCESS)) {
    modules.push(PlatformModules.MiDispatch);
  }

  if (permissions.includes(PERMISSIONS.MI_SCHEDULING.ACCESS)) {
    modules.push(PlatformModules.MiScheduling);
  }

  if (permissions.includes(PERMISSIONS.MI_ACCOUNTING.ACCESS)) {
    modules.push(PlatformModules.MiAccounting);
  }

  return modules;
};

export const getPermissionNameType = (permissionName: string): string => {
  const parts = permissionName.split(":");
  return parts.length > 1 ? parts[parts.length - 1].trim() : permissionName;
};
